"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _Button = _interopRequireDefault(require("@jobmatchme/ui/es/components/styleguide/Button"));

var _trackingService = require("@jobmatchme/frontend-analytics/es/trackingService.js");

var _Profile = require("../../../provider/Profile");

var _FadeIn = _interopRequireDefault(require("@jobmatchme/ui/es/components/FadeIn"));

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var _reactI18next = require("react-i18next");

var _Box = _interopRequireDefault(require("@material-ui/core/Box"));

var _notistack = require("notistack");

var _styleModule = _interopRequireDefault(require("./style.module.scss"));

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var translateNs = 'pc-matching:ProfileNotActive';

var ProfileNotActive = function ProfileNotActive(_ref) {
  var user = _ref.user,
      _ref$onlyButton = _ref.onlyButton,
      onlyButton = _ref$onlyButton === void 0 ? false : _ref$onlyButton;

  var _useSnackbar = (0, _notistack.useSnackbar)(),
      enqueueSnackbar = _useSnackbar.enqueueSnackbar;

  var _useTranslation = (0, _reactI18next.useTranslation)(),
      t = _useTranslation.t;

  var _useContext = (0, _react.useContext)(_Profile.ProfileActionsContext),
      updateProfileState = _useContext.updateProfileState;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      btnState = _useState2[0],
      setBtnState = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      processSuccessState = _useState4[0],
      setProcessSuccessState = _useState4[1];

  var handleProfileState = function handleProfileState(value) {
    if (value) setBtnState(true); // Button Animation

    setTimeout(function () {
      setProcessSuccessState(true);
    }, 1000); // Change Status

    setTimeout(function () {
      updateProfileState(value).then(function () {
        enqueueSnackbar(t("pc-matching:ProfileForm.Validation.Success.profileActive"), {
          variant: 'success',
          anchorOrigin: {
            vertical: 'top',
            horizontal: 'right'
          }
        });
        (0, _trackingService.trackEvent)({
          eventName: 'profileStateChanged',
          pcUuid: user.username,
          payload: {
            active: value
          }
        });
      });
    }, 2500);
  };

  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_FadeIn.default, {
    delay: 600,
    transition: 0.5,
    children: [!onlyButton && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Box.default, {
      className: _styleModule.default.content,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography.default, {
        component: "h1",
        className: _styleModule.default.headline,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Box.default, {
          children: t("".concat(translateNs, ".title"))
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography.default, {
        component: "p",
        className: _styleModule.default.text,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Box.default, {
          children: t("".concat(translateNs, ".description"))
        })
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Box.default, {
      className: _styleModule.default.buttonWrapper,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.default, {
        color: "primary",
        variant: "contained",
        round: true,
        flat: true,
        bold: true,
        texttransform: "none",
        onClick: function onClick() {
          return handleProfileState(true);
        },
        className: _styleModule.default.button,
        loading: {
          start: btnState,
          end: processSuccessState,
          animate: true
        },
        children: t("".concat(translateNs, ".btn"))
      })
    })]
  });
};

var _default = /*#__PURE__*/(0, _react.memo)(ProfileNotActive);

exports.default = _default;